import { AutoComplete, Box, listItemSelectBuilder, Text } from '@wix/design-system';
import { getAllCountries, getCountryByKey } from '@wix/locale-dataset-javascript';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { CountryFlag } from './CountryFlag';
import { includesCaseInsensitive, isOfacCountry } from '../utils';
import { COUNTRY_NAMES } from '../constants';
const popoverProps = {
  appendTo: 'window',
  placement: 'bottom-start',
  moveBy: {
    x: 0,
    y: 0
  },
  zIndex: 7000 // 6000 is the z-index ai-platform container in sites dashboard
};
/**
 * Autocomplete input for country dial code.
 * It uses locale dataset package to get localized list of countries and their dial codes.
 */
export const CountryCode = _ref => {
  let {
    selectedCountry,
    onSelectCountry,
    onFocus,
    onBlur
  } = _ref;
  const [searchValue, setSearchValue] = useState((selectedCountry == null ? void 0 : selectedCountry.dialCode) || '');
  const isSearchingRef = useRef(false);
  const countryOptions = useMemo(() => {
    return getAllCountries().filter(_ref2 => {
      let {
        shortKey
      } = _ref2;
      return isOfacCountry(shortKey);
    }).map(country => {
      return listItemSelectBuilder({
        id: country.key,
        prefix: /*#__PURE__*/React.createElement(Box, {
          direction: "horizontal",
          align: "left",
          flexShrink: 0
        }, /*#__PURE__*/React.createElement(CountryFlag, {
          countryKey: country.key
        })),
        suffix: /*#__PURE__*/React.createElement(Text, {
          secondary: true,
          light: true
        }, country.dialCode),
        title: COUNTRY_NAMES[country.displayName],
        label: COUNTRY_NAMES[country.displayName]
      });
    })
    // Sorting alphabetically by translated country name
    .sort((option1, option2) => (option1.label ?? '').localeCompare(option2.label ?? '', 'en'));
  }, []);
  const onSearchHandler = useCallback(event => {
    isSearchingRef.current = true;
    setSearchValue(event.target.value.trim());
    onSelectCountry(undefined);
  }, [onSelectCountry]);
  const onSelectHandler = useCallback(option => {
    setSearchValue(getCountryByKey(option.id).dialCode);
    onSelectCountry(getCountryByKey(option.id));
  }, [onSelectCountry]);
  const onCloseHandler = useCallback(() => {
    if (!selectedCountry) {
      setSearchValue('');
    }
    isSearchingRef.current = false;
  }, [selectedCountry]);
  const predicateCallback = useCallback(option => {
    if (!isSearchingRef.current) {
      // If search didn't started yet, show all countries
      return true;
    }
    const country = getCountryByKey(option.id);
    // Searching country name, dial code and short key
    return includesCaseInsensitive(option.label, searchValue) || includesCaseInsensitive(country.dialCode, searchValue) ||
    // I want to type US and get United States
    includesCaseInsensitive(country.shortKey, searchValue);
  }, [searchValue]);
  return /*#__PURE__*/React.createElement(AutoComplete, {
    autocomplete: "off",
    size: "small",
    placeholder: "+",
    selectedId: searchValue.trim(),
    value: searchValue,
    options: countryOptions,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onSearchHandler,
    onSelect: onSelectHandler,
    onClose: onCloseHandler,
    predicate: predicateCallback,
    popoverProps: popoverProps,
    dropdownWidth: "270px"
  });
};
//# sourceMappingURL=CountryCode.js.map